/* <product-form> — intercepts add-to-cart, posts via the Ajax cart with the
   drawer + bubble sections, then morphs and opens the drawer. Also handles the
   quantity steppers. Depends on fetchConfig from global.js. */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submit = this.querySelector(".product-form__submit");
    this.errorEl = this.querySelector("[data-form-error]");

    this.form?.addEventListener("submit", (e) => this.onSubmit(e));

    this.addEventListener("click", (e) => {
      const step = e.target.closest("[data-qty-step]");
      if (!step) return;
      const input = this.querySelector(".qty__input");
      if (!input) return;
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.submit?.hasAttribute("disabled")) return;
    this.hideError();
    this.submit?.classList.add("is-loading");
    this.submit?.setAttribute("disabled", "");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"]; // let the browser set the multipart boundary

    const formData = new FormData(this.form);
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((r) => r.json())
      .then((res) => {
        if (res.status) {
          this.showError(res.description || res.message);
          return;
        }
        const drawer = document.querySelector("cart-drawer");
        if (drawer) {
          drawer.renderContents(res);
          drawer.open();
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(() => this.showError(""))
      .finally(() => {
        this.submit?.classList.remove("is-loading");
        this.submit?.removeAttribute("disabled");
      });
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg || "Something went wrong. Please try again.";
    this.errorEl.hidden = false;
  }
  hideError() {
    if (this.errorEl) this.errorEl.hidden = true;
  }
}
if (!customElements.get("product-form")) customElements.define("product-form", ProductForm);
